import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleProp, ViewStyle } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import RgLogo from '@/assets/icons/rgLogo';
import { ButtonMore } from '@/components/ButtonMore';
import { LineSeparator } from '@/components/LineSeparator';
import { SizedBox } from '@/components/SizedBox';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { getUrlFromLinks } from '@/feature/invite-friends/utils/utils';
import { ProductDocumentDataBodyScreenLinksSliceItem } from '@/types/prismic.generated';

type GambleResponsiblyProps = {
    style?: StyleProp<ViewStyle>;
    links?: ProductDocumentDataBodyScreenLinksSliceItem[];
};

export const GameResponsibly = ({ style, links }: GambleResponsiblyProps) => {
    const { t } = useTranslation('raf');
    const navigation = useNavigation();
    const termsAndConditionsLink = links ? getUrlFromLinks({ links, linkType: 'TermsAndConditions' }) : undefined;
    const privacyPolicyLink = links ? getUrlFromLinks({ links, linkType: 'PrivacyPolicy' }) : undefined;
    const houseRulesLink = links ? getUrlFromLinks({ links, linkType: 'HouseRules' }) : undefined;
    const showLinks = !!termsAndConditionsLink && !!privacyPolicyLink && !!houseRulesLink;

    const handlePress = (link: string) => {
        navigation.navigate('ModalWebView', { uri: link });
    };

    return (
        <Box style={style} paddingTop={'s38'} paddingBottom={'s24'}>
            <Box
                pt={'s32'}
                paddingHorizontal={'s16'}
                backgroundColor={ds.colorToken.background.neutral.subtler}
                borderRadius={'r16'}
            >
                <Box alignItems={'center'} paddingHorizontal={'s16'}>
                    <RgLogo />
                    <SizedBox value={16} />
                    <Text variant="titleLarge">{t('game_responsibly_title')}</Text>
                    <SizedBox value={4} />
                    <Text variant="bodySmall" textAlign={'center'} color={ds.colorToken.text.secondary}>
                        {t('gamble_responsibly_description')}
                    </Text>
                </Box>
                <SizedBox value={24} />
                {showLinks ? (
                    <>
                        <ButtonMore
                            label={t('terms_and_conditions')}
                            onPress={() => {
                                if (termsAndConditionsLink) {
                                    handlePress(termsAndConditionsLink);
                                }
                            }}
                        />
                        <LineSeparator />
                        <ButtonMore
                            label={t('house_rules')}
                            onPress={() => {
                                if (houseRulesLink) {
                                    handlePress(houseRulesLink);
                                }
                            }}
                        />
                        <LineSeparator />
                        <ButtonMore
                            label={t('privacy_policy')}
                            onPress={() => {
                                if (privacyPolicyLink) {
                                    handlePress(privacyPolicyLink);
                                }
                            }}
                        />
                    </>
                ) : null}
            </Box>
        </Box>
    );
};
